import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFunnel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.21661 2.72691C1.10817 2.60757 1.03667 2.45932 1.0108 2.30015C0.984924 2.14098 1.00578 1.97772 1.07085 1.83017C1.13591 1.68262 1.24239 1.55711 1.37736 1.46886C1.51233 1.38062 1.67001 1.33343 1.83127 1.33301H20.1667C20.3281 1.33302 20.486 1.37992 20.6213 1.46801C20.7566 1.5561 20.8634 1.68159 20.9287 1.82922C20.994 1.97685 21.0151 2.14027 20.9893 2.29964C20.9635 2.459 20.892 2.60744 20.7834 2.72691L13.4992 10.5007V16.6108C13.4993 16.748 13.4655 16.8832 13.4008 17.0042C13.3361 17.1252 13.2425 17.2284 13.1284 17.3046L9.79466 19.5267C9.66926 19.6104 9.52352 19.6585 9.37296 19.6659C9.22239 19.6732 9.07264 19.6397 8.93966 19.5687C8.80667 19.4977 8.69543 19.392 8.61777 19.2628C8.54012 19.1336 8.49896 18.9857 8.49868 18.835V10.5007L1.21661 2.72691Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFunnel;
